module.exports = __webpack_public_path__ + "img/empreendimento-logo-30.78f6b4e7.png";